<main class="p-4 md:p-3 lg:p-2 bg-white space-y-2 h-screen overflow-y-auto pr-2">
  <section>
    <div class="flex justify-between items-center mb-4 mt-2">
      <div class="text-3xl font-semibold">Performance</div>
      <button
        type="button"
        class="text-sm font-medium text-gray-600 flex items-center gap-2"
        (click)="showAll = !showAll"
      >
        <span>{{ showAll ? 'Collapse' : 'View All' }}</span>
        <img
          [src]="showAll ? '/assets/icons/new-dashboard/dropdown.svg' : '/assets/icons/new-dashboard/dropdown.svg'"
          alt="Toggle"
          class="w-4 h-4"
        />
      </button>
    </div>

    <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 w-full px-0">
      <div
        *ngFor="let card of visibleCards; trackBy: identifyDriver"
        class="w-full rounded-md border border-gray-400 bg-white p-2"
        [style.height.px]="110"
        [style.minHeight.px]="110"
      >
        <div class="flex items-center justify-between">
          <div class="text-lightGray font-inter text-base font-normal leading-normal">
            {{ card.title }}
          </div>
        </div>

        <div class="self-stretch text-darkBlue font-inter text-2xl font-semibold leading-normal">
          {{ card.value }}
        </div>

        <ng-container *ngIf="card.indicatorText !== ''; else notTop25">
          <div class="flex items-center text-sm mt-1">
            <span class="text-gray-500">
              {{ card.subtext }}
            </span>
            <div class="ml-2 inline-flex items-center" [ngClass]="card.indicatorClass">
              <img [src]="card.indicatorIcon" alt="Indicator" class="w-2 h-2" />
              <span class="ml-1" [ngClass]="card.textColor">
                {{ card.indicatorText }}
              </span>
            </div>
          </div>
        </ng-container>
        <ng-template #notTop25>
          <div class="flex items-center text-sm pb-1 mt-0.5">
            <div class="text-gray-500">
              {{ card.subtext }}
            </div>
            <div class="ml-auto flex items-center">
              <div class="ml-2 inline-flex items-center w-5 h-5">
                <img *ngIf="card.indicatorIcon !== ''" [src]="card.indicatorIcon" alt="Indicator" class="w-5 h-5" />
                {{ card.indicatorText }}
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </section>
  </section>

  <section class="w-full" style="margin-top: 50px">
    <mat-tab-group mat-stretch-tabs (selectedTabChange)="switchTab($event.index)">
      <mat-tab label="AVERAGE DAILY PROFIT (PAST 7 DAYS)" style="font-size: 12px">
        <div class="mt-2 border p-2" style="border: 1px solid #d7dde0">
          <div class="text-base font-semibold mb-1">Costs</div>
          <div class="grid grid-cols-2 md:grid-cols-5 gap-4">
            <div *ngFor="let cost of costs; trackBy: identifyDriver" class="flex items-center gap-2">
              <div class="text-base">{{ cost.label }}:</div>

              <div
                class="text-base text-gray-600 flex items-center gap-1"
                [class.text-blue-500]="cost.link"
                [class.cursor-pointer]="cost.link"
                (click)="cost.link ? openUpdateCostsModal(cost) : null"
              >
                {{ cost.value }}/day

                <ng-container *ngIf="cost.link">
                  <img src="./assets/icons/new-dashboard/pen.svg" alt="Edit" class="-ml-1 w-2 h-2 inline-block" />
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <table
          *ngIf="!driverRevenues || !driverRevenues.length"
          class="w-full table-fixed border-collapse border mt-4 animate-pulse"
          style="border: 1px solid #d7dde0; border-collapse: collapse"
        >
          <thead style="height: 96px">
            <tr class="bg-gray-100 rounded-md">
              <th *ngFor="let _ of [1, 2, 3, 4]" class="py-4 px-3 text-left border" style="border-color: #d7dde0">
                <div class="w-32 h-6 bg-gray-300 rounded"></div>
                <div class="w-24 h-6 mt-2 bg-gray-300 rounded"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let _ of [1, 2, 3, 4]"
              class="border-collapse"
              style="border: 1px solid #d7dde0; border-collapse: collapse"
            >
              <td
                class="flex items-center justify-start pl-4 border"
                style="height: 96px; width: 206px; border-color: #d7dde0"
              >
                <div class="w-8 h-8 bg-gray-300 rounded-full mr-2"></div>
                <div class="w-32 h-6 bg-gray-300 rounded"></div>
              </td>
              <td
                *ngFor="let _ of [1, 2, 3]"
                class="bg-gray-300 font-semibold text-gray-700 text-left pl-4 border"
                style="height: 96px; width: 206px; font-size: 18px; border-color: #d7dde0"
              >
                <div class="w-24 h-6 bg-gray-300 rounded"></div>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          *ngIf="driverRevenues && driverRevenues.length"
          class="w-full table-fixed border-collapse border mt-4"
          style="border: 1px solid #d7dde0; border-collapse: collapse"
        >
          <thead style="height: 96px">
            <tr class="bg-gray-100 rounded-md">
              <th class="py-4 px-3 text-left border" style="border-color: #d7dde0">
                <p class="text-gray-500 font-medium">Avg. Profit Per Day</p>
                <p class="flex space-x-2">
                  <span class="text-black font-bold text-2xl">{{ totalDriverRevenues }}</span>
                </p>
              </th>
              <th class="py-4 px-3 text-left border" style="border-color: #d7dde0">
                <p class="text-blue-500 font-medium">To increase profit...</p>
                <p class="flex space-x-2">
                  <span class="text-black font-bold text-2xl">Profit/day</span>
                </p>
              </th>
              <th class="py-4 px-3 text-left border" style="border-color: #d7dde0">
                <p class="text-green-500 font-medium">Increase this...</p>
                <p class="flex space-x-2">
                  <span class="text-black font-bold text-2xl">Revenue/day</span>
                </p>
              </th>
              <th class="py-4 px-6 text-left border" style="border-color: #d7dde0">
                <p class="text-red-500 font-medium">or decrease this</p>
                <p class="flex space-x-2">
                  <span class="text-black font-bold text-2xl">Costs/day</span>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let driver of driverRevenues; trackBy: identifyDriver"
              class="border-collapse"
              style="border: 1px solid #d7dde0; border-collapse: collapse"
            >
              <td
                class="flex items-center justify-start pl-4"
                style="height: 96px; width: 206px; border-color: #d7dde0"
              >
                <img [src]="driver.tierName | typeBadge" alt="Driver Avatar" class="w-3 h-3 rounded-full mr-2" />
                <span class="text-lg font-bold">{{ driver.driverName }}</span>
              </td>
              <td
                class="bg-gray-300 font-semibold text-gray-700 text-left pl-4 border"
                style="height: 96px; width: 206px; font-size: 18px; border-color: #d7dde0"
              >
                <span class="text-2xl">{{ driver.totalProfit }}</span>
              </td>
              <td
                class="font-semibold text-gray-700 text-left pl-4 border"
                style="height: 96px; width: 206px; font-size: 18px; border-color: #d7dde0"
              >
                <span class="text-2xl">{{ driver.totalRevenue }}</span>
              </td>
              <td
                class="bg-gray-300 font-semibold text-2xl text-gray-700 text-left pl-4 border"
                style="height: 96px; width: 206px; font-size: 18px; border-color: #d7dde0"
              >
                <span class="text-2xl">{{ driver.totalCost }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-tab>

      <mat-tab label="  LOST REVENUE BY DRIVER MISTAKE (PAST 7 DAYS)" style="font-size: 12px">
        <lohi-app-carrier-performance></lohi-app-carrier-performance>
      </mat-tab>
    </mat-tab-group>
  </section>
</main>
